/** @jsxImportSource theme-ui */
import { Box, Label, Flex, Grid } from 'theme-ui';
import { useState } from 'react';
import { Formik, FormikProps } from 'formik';
import qs from 'qs';
import { nanoid } from 'nanoid';
import { useSearchParams } from 'react-router-dom';
import Button from '@/components/Button';
import { GrayFormikField } from '@/components/GrayFormikField';
import CustomDatePicker from '@/components/CustomDatePicker';
import { useGetCompaniesQuery } from '@/store/apiService';

// TODO: load the CompanyId value into dropdownsearch from searchParams

const FilterBalances: React.FC = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [companySearch, setCompanySearch] = useState('');
    const companies = useGetCompaniesQuery({ Take: 20, Search: companySearch });

    const initialValues = {
        CompanyId: '',
        InvoiceDate: '',
        ScheduledStartTime: '',
        OnlyUsage: false,
        ...qs.parse(searchParams.toString()),
    };

    return (
        <Formik
            initialValues={initialValues}
            onSubmit={(values, { resetForm, setErrors, setSubmitting }) => {
                setSearchParams(qs.stringify({ ...values, rand: nanoid(6) }));
                setSubmitting(false);
            }}
        >
            {(props: FormikProps<any>) => (
                <>
                    <Grid
                        sx={{
                            '@media (width > 700px)': {
                                gridTemplateColumns: 'minmax(200px, 1fr) minmax(200px, 1fr)',
                            },
                        }}
                    >
                        <Box variant="form-field">
                            <GrayFormikField
                                name="CompanyId"
                                value={props.values.CompanyId}
                                type="dropdownsearch"
                                label="Company"
                                placeholder="Search companies"
                                onSearchChange={(val) => {
                                    setCompanySearch(val);
                                }}
                                onSelect={(item) => {
                                    props.setFieldValue('CompanyId', item?.value);
                                }}
                                items={companies.data?.Results?.map((company) => ({
                                    value: company.Id,
                                    label: `${company.Name} (${company.Email})`,
                                }))}
                                isLoading={companies.isFetching}
                                total={companies.data?.Total}
                            />
                        </Box>
                        <Box>
                            <Label>Valid From</Label>
                            <CustomDatePicker
                                variation="normal"
                                field={{
                                    name: 'InvoiceDate',
                                    value: !props.values.InvoiceDate
                                        ? null
                                        : new Date(props.values.InvoiceDate),
                                }}
                                onChange={(value) => {
                                    props.setFieldValue('InvoiceDate', value.toISOString());
                                }}
                            />
                        </Box>
                        <Box>
                            <Label>Scheduled start time</Label>
                            <CustomDatePicker
                                variation="normal"
                                field={{
                                    name: 'ScheduledStartTime',
                                    value: !props.values.ScheduledStartTime
                                        ? null
                                        : new Date(props.values.ScheduledStartTime),
                                }}
                                onChange={(value) => {
                                    props.setFieldValue('ScheduledStartTime', value.toISOString());
                                }}
                            />
                        </Box>
                        <Box sx={{ alignSelf: 'end' }}>
                            <GrayFormikField type="checkbox" label="Only usage" name="OnlyUsage" />
                        </Box>
                    </Grid>
                    <Flex
                        p="2"
                        sx={{
                            width: '100%',
                            gap: 2,
                            justifyContent: 'flex-end',
                        }}
                    >
                        <Button
                            variant="secondary"
                            onClick={() => {
                                props.resetForm();
                                setSearchParams('');
                            }}
                        >
                            Clear
                        </Button>
                        <Button
                            isLoading={props.isSubmitting}
                            disabled={props.isSubmitting}
                            type="submit"
                            onClick={props.submitForm}
                        >
                            Apply
                        </Button>
                    </Flex>
                </>
            )}
        </Formik>
    );
};

export default FilterBalances;
